<template>
  <div class="flex flex-col gap-y-3">
    <CollapsibleSection :header-label="$t('identificationInformation')" body-class="flex flex-wrap">
      <div class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5">
        <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
          {{ $t('fileNumber') }}:
        </span>
        <span class="md:w-2/3">
          {{ fileValidityStore.result.fileNumberFull }}
        </span>
      </div>
      <div
        v-if="fileValidityStore.result.unifiedNumber"
        class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5"
      >
        <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
          {{ i18n.t('unifiedNumber') }}:
        </span>
        <span class="md:w-2/3">
          {{ fileValidityStore.result.unifiedNumber }}
        </span>
      </div>

      <div
        v-if="fileValidityStore.result.identityCardNumber"
        class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5"
      >
        <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
          {{ i18n.t('EmiratesIDNumber') }}:
        </span>
        <span class="md:w-2/3">
          {{ fileValidityStore.result.identityCardNumber }}
        </span>
      </div>

      <div
        v-if="fileValidityStore.result.eidaCardExpiryDate"
        class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5"
      >
        <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
          {{ i18n.t('EmiratesIDExpiryDate') }}:
        </span>
        <span class="md:w-2/3">
          {{ fileValidityStore.result.eidaCardExpiryDate }}
        </span>
      </div>

      <div
        v-if="fileValidityStore.result.eidaCardNo"
        class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5"
      >
        <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
          {{ i18n.t('EmiratesIDCardNumber') }}:
        </span>
        <span class="md:w-2/3">
          {{ fileValidityStore.result.eidaCardNo }}
        </span>
      </div>

      <div
        v-if="fileValidityStore.result.eidaCardIssueDate"
        class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5"
      >
        <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
          {{ i18n.t('EmiratesIDIssueDate') }}:
        </span>
        <span class="md:w-2/3">
          {{ fileValidityStore.result.eidaCardIssueDate }}
        </span>
      </div>
    </CollapsibleSection>
    <CollapsibleSection
      v-if="
        !fileValidityStore.submittedValues.iSGCCCitizen &&
        fileValidityStore.result.eidaCardNumber &&
        fileValidityStore.inquiryAboutIDN
      "
      :header-label="$t('eidaformation')"
      body-class="flex flex-wrap"
    >
      <div
        v-if="fileValidityStore.result.identityCardNumber"
        class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5"
      >
        <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
          {{ $t('EmiratesIDNumber') }}:
        </span>
        <span class="md:w-2/3">
          {{ fileValidityStore.result.identityCardNumber }}
        </span>
      </div>

      <div
        v-if="fileValidityStore.result.eidaCardIssueDate"
        class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5"
      >
        <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
          {{ $t('EmiratesIDIssueDate') }}:
        </span>
        <span class="md:w-2/3">
          {{ fileValidityStore.result.eidaCardIssueDate }}
        </span>
      </div>

      <div
        v-if="fileValidityStore.result.eidaCardExpiryDate"
        class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5"
      >
        <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
          {{ $t('EmiratesIDExpiryDate') }}:
        </span>
        <span class="md:w-2/3">
          {{ fileValidityStore.result.eidaCardExpiryDate }}
        </span>
      </div>

      <div
        v-if="fileValidityStore.result.eidaCardNumber"
        class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5"
      >
        <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
          {{ $t('EmiratesIDCardNumber') }}:
        </span>
        <span class="md:w-2/3">
          {{ fileValidityStore.result.eidaCardNumber }}
        </span>
      </div>
    </CollapsibleSection>
    <CollapsibleSection
      v-if="
        !fileValidityStore.submittedValues.iSGCCCitizen &&
        !fileValidityStore.isInquiryAboutIdNumber &&
        !fileValidityStore.isApplicableForFiveYearTouristVisa &&
        !fileValidityStore.isApplicableForVisaSummary
      "
      :header-label="$t('fileInformation')"
      body-class="flex flex-wrap"
    >
      <div
        v-if="fileValidityStore.result.serviceStatus"
        class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5"
      >
        <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
          {{ $t('fileStatus') }}:
        </span>
        <span class="md:w-2/3">
          {{ fileValidityStore.result.serviceStatus?.text }}
        </span>
      </div>

      <div
        v-if="!fileValidityStore.result.expireDate"
        class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5"
      >
        <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
          {{ $t('visaValidityDate') }}:
        </span>
        <span class="md:w-2/3">
          {{ fileValidityStore.result.validityDate }}
        </span>
      </div>

      <div v-else class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5">
        <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
          {{ $t('fileExpireDate') }}:
        </span>
        <span class="md:w-2/3">
          {{ fileValidityStore.result.expireDate }}
        </span>
      </div>

      <div
        v-if="
          fileValidityStore.result.allowedStayInDate &&
          fileValidityStore.isApplicableForFiveYearTouristVisa === false
        "
        class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5"
      >
        <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
          {{ $t('LastDateOfLeavingCountry') }}:
        </span>
        <span class="md:w-2/3">
          {{ fileValidityStore.result.allowedStayInDate }}
        </span>
      </div>

      <div
        v-if="fileValidityStore.result.numberOfVisaStayDays > -1"
        class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5"
      >
        <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
          {{ $t('numberOfDaysSpentInsideTheCountry') }}:
        </span>
        <span class="md:w-2/3">
          {{ fileValidityStore.result.numberOfVisaStayDays }}
        </span>
      </div>

      <div
        v-if="fileValidityStore.result.numberOfVisaOverStayDays > -1"
        class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5"
      >
        <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
          {{ $t('numberOfDaysSpentInsideTheCountry') }}:
        </span>
        <span class="md:w-2/3">
          {{ fileValidityStore.result.numberOfVisaOverStayDays }}
        </span>
      </div>

      <div
        v-if="fileValidityStore.result.numberOfVisaRemainingBalanceDays > -1"
        class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5"
      >
        <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
          {{ $t('numberOfDaysSpentInsideTheCountry') }}:
        </span>
        <span class="md:w-2/3">
          {{ fileValidityStore.result.numberOfVisaRemainingBalanceDays }}
        </span>
      </div>

      <div
        v-if="fileValidityStore.showResidencyStayingDays"
        class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5"
      >
        <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
          {{ $t('totalResidencyStayingDays') }}:
        </span>
        <span class="md:w-2/3">
          {{ fileValidityStore.result.totalResiStayingDays }}
        </span>
      </div>
      <div class="pt-6 w-full flex gap-x-4">
        <RouterLink
          v-if="fileValidityStore.showEnableExtendVisaSection"
          :to="{
            name: 'PublicvisaExtension',
            query: {
              extendVisa: 2,
              fileDepartmentCode: fileValidityStore.result.fileDepartmentCode,
              fileSequenceNumber: fileValidityStore.result.fileSequenceNumber,
              fileServiceCode: fileValidityStore.result.fileServiceCode,
              fileServiceYear: fileValidityStore.result.fileServiceYear,
              nationality: fileValidityStore.result.personNationality,
              dob: fileValidityStore.result.personDateOfBirth
            }
          }"
          class="px-2 py-0.5 text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
        >
          {{ $t('applyForVisaExtensionFromHere') }}
        </RouterLink>
        <RouterLink
          v-if="fileValidityStore.showEnablePreExtendVisaSection"
          :to="{
            name: 'PublicvisaExtension',
            query: {
              extendVisa: 5,
              fileDepartmentCode: fileValidityStore.result.fileDepartmentCode,
              fileSequenceNumber: fileValidityStore.result.fileSequenceNumber,
              fileServiceCode: fileValidityStore.result.fileServiceCode,
              fileServiceYear: fileValidityStore.result.fileServiceYear,
              nationality: fileValidityStore.result.personNationality,
              dob: fileValidityStore.result.personDateOfBirth
            }
          }"
          class="px-2 py-0.5 text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
        >
          {{ $t('applyForPreEntryExtensionFromHere') }}
        </RouterLink>
      </div>
    </CollapsibleSection>

    <template
      v-if="
        fileValidityStore.oldFiles?.length > 0 && !fileValidityStore.submittedValues.iSGCCCitizen
      "
    >
      <div class="w-full flex">
        <label for="showOldFiles">
          <input id="showOldFiles" type="checkbox" @change="toggleOldFileSection()" class="accent-primary" />
          {{ $t('viewOldFiles') }}
        </label>
      </div>
      <CollapsibleSection v-if="showOldFiles" :header-label="$t('myOldFile')" body-class="!p-0">
        <DataTableVue :data-set="fileValidityStore.oldFilesAsDatatable" />
      </CollapsibleSection>
    </template>
  </div>
</template>

<script setup>
import DataTableVue from '@/components/DataTable/index.vue'
import CollapsibleSection from '@/components/Ui/CollapsibleSection.vue'
import { useFileValidityStore } from '@/stores/file_validity'
import { useToggle } from '@vueuse/core'
import { useI18n } from 'vue-i18n'

const [showOldFiles, toggleOldFileSection] = useToggle()

const i18n = useI18n({
  messages: {
    en: {
      unifiedNumber: 'Emirate Unified Number'
    },
    ar: {
      unifiedNumber: 'الرقم الموحد للإمارات'
    }
  }
})

const fileValidityStore = useFileValidityStore()
</script>

<style lang="scss" scoped></style>
